import React, { useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  searchAppViewList,
} from "@store/actions/appViewAction";
import * as appListAction from '@store/actions/appListAction';
import { addDates, getToday } from '@common/utils';

const SnbMenuHeaderUser = () => {
  const { tokenInfo } = $hooks.useUser();

  const history = useHistory();
  const dispatch = useDispatch();
  //const { appViewReducer :{appViewList,}}= useSelector(state => state.appViewReducer);

  //const data = useSelector(state => state.appViewReducer.appViewList);
  const appViewList = useSelector(state => state.appViewReducer.appViewList);


  useEffect(() => {
    dispatch(searchAppViewList());

  }, [dispatch]);


  const moveToAppList = () => {
    dispatch(
      appListAction.saveSearchParms({
        searchStartDate: addDates(getToday(), 'months', -1, 'yyyyMMdd'),
        searchEndDate: getToday('yyyyMMdd'),
        searchState: 'ALL',
        pageIndex: '1',
        custNo: '',
        searchName: '',
        pageConditionKey: '',
        pageCount: 10,
        pageNextYn: '',
      }),
    );

    history.push('/appView');
  };

  if (
    ( tokenInfo.roleIds[0] === 'LOS_LP_SM' || tokenInfo.roleIds[0] === 'LOS_LP_AM' ) &&
    //( appViewList.some(data => data.mgrApprovedYn === 'Y'))
       ( appViewList.filter(data => data.mgrApprovedYn === 'N').length > 0 )
  ) {
    return (
      <><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEHSURBVHgBxVIxTsNAENw950yExGXLSMTWPcH8AF5AfgAdJeIBKAUPQJRUfCV5AflBrkhBebhACXFu8SYCJbYjSzSZ5vZ2Z3ZWdxvBAcSUDLFr+mGRu6Z6pzFJ9jIw32zjARR+Pq5ycPfSJWvXzG8MAZBhumXgUEgK1dXCO1dzEVHcS2cdMxjVxjbpSGpARL+56M86Ns8A7Ip8/lAVrpefE3VirOI4C8t8slfUvfRd03kGByATaXGtokwytGCXo+CfOJJQU3JbHtN2Oo6js+Raos3mMEQOIWRtD8TAvvzAzdJgrUqWNIfZ490pSZen1y9f4PcF+A+3593YmvpWB30v4UqtXqoiwQ8qv02yBwS++wAAAABJRU5ErkJggg=="   onClick={moveToAppList} style={{cursor: 'pointer'}}/></>
    );
  }else{
    return (
      <>  </>

    );  }




};

export default SnbMenuHeaderUser;
